import { Button } from '@/components/ui/button';

interface DecisionPanelProps {
  options: Array<{
    text: string;
    next_node: string;
    score: number;
  }>;
  onChoose: (index: number) => void;
  disabled?: boolean;
}

export function DecisionPanel({ options, onChoose, disabled }: DecisionPanelProps) {
  return (
    <div className="space-y-3">
      <p className="font-medium text-muted-foreground">What would you do?</p>
      {options.map((option, idx) => (
        <Button
          key={idx}
          variant="outline"
          className="h-auto w-full justify-start whitespace-normal px-4 py-3 text-left"
          onClick={() => onChoose(idx)}
          disabled={disabled}
        >
          {option.text}
        </Button>
      ))}
    </div>
  );
}
